(function (upp) {
    'use strict';

    upp.service('modal', ['$timeout', '$sce', 'translator', '$http', '$rootScope', '$q', '$document', '$templateCache', '$controller','$compile', '$animate' ,
        function ($timeout, $sce, translator, $http, $rootScope, $q, $document, $templateCache, $controller, $compile, $animate) {

            //  Returns a promise which gets the template, either
            //  from the template parameter or via a request to the
            //  template url parameter.
            var getTemplate = function (template, templateUrl) {
                var deferred = $q.defer();
                if (templateUrl) {
                    $http.get(templateUrl, {
                        cache: $templateCache
                    }).then(function(result) {
                        deferred.resolve(result.data);
                    });
                } else {
                    deferred.resolve(template);
                }
                return deferred.promise;
            };

            //  Adds an element to the DOM as the last child of its container
            //  like append, but uses $animate to handle animations. Returns a
            //  promise that is resolved once all animation is complete.
            var appendChild = function(parent, child) {
                var children = parent.children();
                if (children.length > 0) {
                    return $animate.enter(child, parent, children[children.length - 1]);
                }
                return $animate.enter(child, parent);
            };

            //params are translated in the own template with the filter 'i18n' expect the msg, witch is explicitly translated here because some messages can be pluralized, and this can't be done (or I don't know) in the template
            var publishParams = function (options, scope) {
                scope.title = options.title;
                scope.img = options.img;
                scope.message = $sce.trustAsHtml(translateMsg(options.message));
                scope.closeButton = options.closeButton;

                if (options.confirmButton) {
                    scope.confirmButton = options.confirmButton;
                    scope.confirm = options.confirmButton.callback;
                }

                if (options.closeButton) {
                    scope.closeButton = options.closeButton;
                    scope.close = options.closeButton.callback;
                }

                //FIXME. without it, second callings do not work
                if (!scope.$$phase) {
                    scope.$apply();
                }

            };

            /**
             * @method translateMsg
             * @param msg {Object|String}
             * @returns {String}
             */
            var translateMsg = function (msg) {
                if (typeof msg === "string") {
                    msg = translator.i18n(msg);
                } else if (msg.hasOwnProperty("key")) {
                    if (msg.hasOwnProperty("pluralize")) {
                        msg = translator.pluralizeI18n(msg.key, msg.pluralize);
                    } else if (msg.hasOwnProperty("params")) {
                        msg = translator.i18n(msg.key, msg.params);
                    }
                }
                return msg;
            };

            var singleton = {
                $compile: $compile,
                angular: angular,
                $controller: $controller,
                $q: $q,
                $timeout: $timeout,
                $sce: $sce,
            };

            /**
             * Create the modal with the given options.
             *
             * @see https://github.com/dwmkerr/angular-modal-service
             * TODO: add controller
             *
             * @param options {Object}
             *  - templateUrl, {String} The URL of the HTML template to use for the modal.
             *  - template, {String} If templateUrl is not specified, you can specify template as raw HTML for the modal.
             *  - scope, {Object} Optional. If provided, the modal controller will use a new scope as a child of scope
             *  (created by calling scope.$new()) rather than a new scope created as a child of $rootScope.
             *  - attrs, {Object} values to assign to the new scope created TODO: review this (copied from the old modal)
             *  - inputs, {Object} to pass to the modal created
             *  - appendElement, {Object} The custom angular element to append the modal to instead of default body element.
             *  - bodyClass, {String} Optional. The custom css class to append to the body while the modal is open (optional, useful when not using Bootstrap).
             *
             *
             * @return {Promise} with the modal element
             *  - modal.element - The created DOM element. This is a jquery lite object (or jquery if full jquery is used).
             *  If you are using a bootstrap modal, you can call modal on this object to show the modal.
             *  - modal.scope - The new scope created for the modal DOM and controller.
             *  - show, {Function} attach the modal to the body and open the modal
             */
            singleton.showModal = function(options) {
                //  Get the body of the document, we'll add the modal to this.
                var body = this.angular.element($document[0].body);
                var self = this;

                //  Create a deferred we'll resolve when the modal is ready.
                var deferred = this.$q.defer();

                //  Get the actual html of the template.
                getTemplate(options.template, options.templateUrl)
                    .then(function(template) {
                        //  The main modal object we will build.
                        var modal = {
                            options: options,
                            show: function () {
                                var deferredOpen = $q.defer();
                                //  Then, append the modal to the dom.
                                if (this.options.appendElement) {
                                    // append to custom append element
                                    appendChild(this.options.appendElement, modalElement);
                                } else {
                                    // append to body when no custom append element is specified
                                    appendChild(body, modalElement);
                                }

                                // Finally, append any custom classes to the body
                                if(this.options.bodyClass) {
                                    body[0].classList.add(this.options.bodyClass);
                                }

                                this.element.on('shown.bs.modal', function () {
                                    //  deffered on open
                                    deferredOpen.resolve(modal);
                                });

                                this.element.modal();
                            }
                        };

                        //  Create a new scope for the modal.
                        var modalScope = (options.scope || $rootScope).$new();
                        publishParams(options.attrs, modalScope);

                        //  Create the inputs object to the controller - this will include
                        //  the scope, as well as all inputs provided.
                        var inputs = {
                            $scope: modalScope
                        };

                        //  If we have provided any inputs, pass them to the controller.
                        if (options.inputs) angular.extend(inputs, options.inputs);

                        //  Compile then link the template element, building the actual element.
                        //  Set the $element on the inputs so that it can be injected if required.

                        var linkFn = self.$compile(template);
                        var modalElement = linkFn(modalScope);
                        inputs.$element = modalElement;
                        //  Populate the modal object...
                        modal.scope = modalScope;
                        modal.element = modalElement;


                        modal.element.on('show.bs.modal', function () {
                            //console.log('The modal is about to be shown.');
                        });

                        modal.element.on('shown.bs.modal', function () {
                            //console.log('shown.');
                        });

                        modal.element.on('hidden.bs.modal', function () {
                            // do something…
                            modal.element.remove();
                            //  We can now clean up the scope
                            modal.scope.$destroy();
                        });

                        //  ...which is passed to the caller via the promise.
                        deferred.resolve(modal);

                    })
                    .then(null, function(error) { // 'catch' doesn't work in IE8.
                        deferred.reject(error);
                    });

                return deferred.promise;
            };

            return {
                get : function(opts) {
                    return singleton.showModal(opts);
                }
            }
        }]);

})(upp);



// WEBPACK FOOTER //
// ./src/app/common/services/modal-service.js